import * as React from 'react';
import { cx } from 'linaria';
import { TreeComponent, TreeProps } from './tree.types';
import { flattenReactChildren } from '../utils/flatten-react-children';
import { useTree } from './use-tree';
import { TreeContext } from './tree.context';
import { TreeNode } from './tree-node';
import * as styles from './tree.styles';
import { FocusScope } from '../focus-scope';

export const Tree: TreeComponent = React.forwardRef<HTMLDivElement, React.PropsWithChildren<TreeProps>>(
    (props, ref) => {
        const { children, openNodes, selectedNode, onChange, defaultOpenNodes } = props;

        const contextValue = useTree({
            selectedNode,
            openNodes,
            defaultOpenNodes,
            onChange,
        });
        const flatChildren = flattenReactChildren(children);

        return (
            <div ref={ref}>
                <FocusScope>
                    <TreeContext.Provider value={contextValue}>
                        <div className={cx(styles.rootTreeStyle)}>
                            <ul>
                                {React.Children.map(flatChildren, (child, index) => {
                                    return React.cloneElement(child as React.ReactElement, {
                                        nodeId: `${index}`,
                                        currentIndex: index,
                                        level: 1,
                                    });
                                })}
                            </ul>
                        </div>
                    </TreeContext.Provider>
                </FocusScope>
            </div>
        );
    },
);

Tree.displayName = 'Tree';
Tree.Node = TreeNode;
